import { ObjectSchema, number, object, string, boolean, array, date, StringSchema } from 'yup';
import { ProjectStatus, Vessel } from './../../models/vessel';
import { GenericErrorStrings } from './../../validators/validation-errors/generic';
import * as yup from 'yup';
import { locale } from './../yup-locale';
import './../custom-method';
yup.setLocale(locale);

export const drawingIdLenLimit = 16;

export function vesselValidator(): ObjectSchema<Vessel> {
    return object({
        id: string().uuid().strict().nullable(),
        name: string().strict().max(16),
        number: string().IsAlphaNumeric().required().nonNullable().strict().max(16),
        drawingId: string().IsAlphaNumeric().required().nonNullable().strict().max(16),
        shipyardId: string().uuid().required().nonNullable().strict(),
        numberOps: number().required().nonNullable().strict().moreThan(0).lessThan(17),
        numberFcu: number().required().nonNullable().strict().moreThan(0).lessThan(9),
        numberOfChannels: number().notRequired(),
        locked: boolean().required().nonNullable().strict(),
        createdBy: string().required().nonNullable().strict(),
        creationDate: string().required().nonNullable().strict(),
        templateVessel: string().strict().nullable(),
        templateShipyard: string().strict().nullable(),
        templateVersion: string().strict().nullable(),
        projectVersion: string().strict().nullable(),
        ownerOid: string().strict().nullable(),
        ownerName: string().strict().nullable(),
        iAPIVesselId: string().strict().nullable(),
        versionStartDate: date().strict().nullable(),
        projectStatus: string()
            .oneOf([ProjectStatus.undefined, ProjectStatus.Editing, ProjectStatus.PendingApproval])
            .required()
            .nonNullable()
            .strict(),
        Mimics: array().notRequired().nullable(),
        VesselAccessRequests: array().notRequired().nullable(),
    })
        .strict()
        .noUnknown();
}

export function drawingIdValidation(): ObjectSchema<any> {
    return object({
        drawingId: string()
            .IsAlphaNumeric()
            .nonNullable()
            .required()
            .max(16, GenericErrorStrings.ABOVE_MAXIMUM)
            .strict(),
    })
        .noUnknown()
        .strict();
}
